import styled from 'styled-components';

export const Wrapper = styled.div`
  height:100vh;overflow:auto;padding:.3rem;
  padding-bottom:0;padding-bottom:env(safe-area-inset-bottom);background:#F7F7F7;
`;

export const Container = styled.div`
  .card{
    height: 1.9rem;background: linear-gradient(204deg, #9DC6ED 0%, #85A5D5 100%);border-radius: .1rem;
    display:flex;align-items:center;justify-content:center;
    font-size: .36rem;font-weight: 500;color: #FFFFFF;padding:0 .4rem;
    span{
      flex:1;
    }
  }
  .card2{
    background: linear-gradient(204deg, #A0CCED 0%, #85C6D5 100%);
    img{
      width:.68rem;height:.5rem;display:block;
    }
    p{
      flex:1;text-align:right;
    }
  }
  .btns{
    .btn{
      height: .9rem;background: #5799FF;border-radius: .1rem;font-size: .36rem;font-weight: 400;color: #FFFFFF;margin-top:.6rem;
      display:flex;align-items:center;justify-content:center;
    }
  }
`;